module.exports = "/cyber/_next/static/images/hero-bg-mobile-31547ae14e3476ff62d8ebe098e553a0.jpg";